import React, { useCallback, useEffect, useState } from "react";
import { MonthCalendar } from "../../../pages/financialAdvisor/appointments/calendars/monthCalendar.tsx";
import { WeekCalendar } from "../../../pages/financialAdvisor/appointments/calendars/weekCalendar.tsx";
import { AppointmentsDTO } from "../../../pages/financialAdvisor/appointments/dto.ts";
import { MonthCalendarFilters } from "../../../pages/financialAdvisor/appointments/filters/monthFilters.tsx";
import { WeekCalendarFilters } from "../../../pages/financialAdvisor/appointments/filters/weekFilters.tsx";
import { findAllAppointments, setPeriod } from "../../../pages/financialAdvisor/appointments/slice.ts";
import { useAppDispatch, useAppSelector } from "../../redux/hook.ts";
import { useMonthCalendar } from "./monthCalendar.ts";
import { useWeekCalendar } from "./weekCalendar.ts";

export const useCalendar = () => {
    const dispatch = useAppDispatch();
    const authState = useAppSelector(state => state.auth)
    const period = useAppSelector((state) => state.appointments.period);
    const appointments = useAppSelector((state) => state.appointments.appointments[period]);
    const monthCalendar = useMonthCalendar();
    const weekCalendar = useWeekCalendar();
    const [visible, setVisible] = useState(false);
    const [appointmentsDetails, setAppointmentDetails] = useState<AppointmentsDTO[]>([]);
    const [appointment, setAppointment] = useState<AppointmentsDTO | null>(null);

    const changePeriod = (period: 'month' | 'week') => {
        dispatch(setPeriod(period));
    };

    const filters = period === 'month' ? monthCalendar.filters : weekCalendar.filters;

    const loadAppointments = useCallback(() => {
        dispatch(findAllAppointments({ filters: { ...filters, financialAdvisorId: authState.findMeFinancialAdvisorResponse?.id! }, period }));
    }, [dispatch, filters]);

    useEffect(() => {
        loadAppointments();
    }, [loadAppointments]);


    return {
        visible,
        setVisible,
        appointmentsDetails,
        setAppointmentDetails,
        appointments: appointments.data,
        status: appointments.status,
        appointment,
        loadAppointments,
        period,
        changePeriod,
        calendar: period === 'week' ? weekCalendar : monthCalendar,
        calendarComponent: period === 'week' ?
            <WeekCalendar
                setAppointment={((appointment: AppointmentsDTO) => setAppointment(appointment))}
                filters={weekCalendar.filters} appointments={appointments.data?.data ?? []}
                setModalVisible={(visible) => setVisible(visible)}
                setAppointmentDetails={(appointments) => setAppointmentDetails(appointments)}
            /> :
            <MonthCalendar
                setAppointment={((appointment: AppointmentsDTO) => setAppointment(appointment))}
                appointments={appointments.data?.data ?? []}
                filters={monthCalendar.filters}
                setModalVisible={(visible) => setVisible(visible)}
                setAppointmentDetails={(appointments) => setAppointmentDetails(appointments)}
            />,
        filterComponents:
            period === 'week' ?
                <WeekCalendarFilters
                    filters={weekCalendar.filters}
                    changePeriod={function (period: "month" | "week"): void {
                        changePeriod(period);
                    }}
                    changeInterval={function (action: "next" | "prev" | "today"): void {
                        weekCalendar.changeInterval(action);
                    }}
                />
                :
                <MonthCalendarFilters
                    filters={monthCalendar.filters}
                    changePeriod={function (period: "month" | "week"): void {
                        changePeriod(period);
                    }}
                    changeInterval={function (action: "next" | "prev" | "today"): void {
                        monthCalendar.changeInterval(action);
                    }}
                />
    };
};
